import http from './http.service';

class TempRankingService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/tempRanking";
    }

    load(id) {
        return this.$http.get(`${this.baseUrl}/getById/${id}`);
    }

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}`, model);
    }

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}`, model);
    }

    loadTempRankingToConfirm(userId) {
        return this.$http.get(`${this.baseUrl}/tempRankingToConfirmForUser/${userId}`);
    }

    getUpcoming() {
        return this.$http.get(`${this.baseUrl}/upcomingEvents`);
    }

    confirmTampRanking(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/confirm`, model);
    }


    rejectTampRanking(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/reject`, model);
    }

    apply(id) {
        return this.$http.get(`${this.baseUrl}/applyTempRanking/${id}`);
    }

    notifyAdmitted(id) {
        return this.$http.get(`${this.baseUrl}/notifyAdmitted/${id}`);
    }

    notifySelectedAdmitted(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/notifySelectedAdmitted`, model);
    }

    notifySelectedRejected(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/notifySelectedRejected`, model);
    }

    notifySelectedReserve(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/notifySelectedReserve`, model);
    }

    applyToParticipation(id) {
        return this.$http.get(`${this.baseUrl}/applyToParticipation/${id}`);
    }

    rank(eventId) {
        if (!eventId) {
            throw new Error('EventId is required');
        }

        return this.$http.get(`${this.baseUrl}/rank/${eventId}`);
    }

    activate(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/activate`, model);
    }

    deactivate(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/deactivate`, model);
    }

    getStatistics(tempRankingId) {
        return this.$http.get(`${this.baseUrl}/statistics/${tempRankingId}`);
    }

    createTempRankingCandidate(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/createTempRankingCandidate`, model);
    };

    updateTempRankingCandidate(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateTempRankingCandidate`, model);
    };

    deleteTempRankingCandidate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteTempRankingCandidate`, { params: { id: id } });
    };

    getCandidateById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getCandidateById/${id}`);
    };

    getRankingConfirmationDetails(id) {
        return this.$http.get(`${this.baseUrl}/getRankingConfirmationDetails/${id}`);
    }

    getConfirmationRejectionDetails(id) {
        return this.$http.get(`${this.baseUrl}/getConfirmationRejectionDetails/${id}`);
    }

    deleteRankingConfirmation(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteRankingConfirmation`, { params: { id: id } });
    };

    loadHistory(eventId) {
        return this.$http.get(`${this.baseUrl}/historyData/${eventId}`);
    }

    syncWithFormEntityData(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.post(`${this.baseUrl}/syncWithFormEntityData`, { id: id });
    };

    syncAllWithFormEntityData(rankingId) {
        if (!rankingId) {
            throw new Error('RankingId is required');
        }

        return this.$http.post(`${this.baseUrl}/syncAllWithFormEntityData`, { id: rankingId });
    };

    updateMultiple(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateMultiple`, model);
    }
}

export default new TempRankingService();
